import { PerspectiveCamera } from "three"
import { Utils } from "/src/scripts/utils"

export { Camera }

class Camera extends PerspectiveCamera {
    #amplitude = .01
    #aspect = 1
    #offset = 0
    #timeout
    #clock
    #size

    #track({ clientX, clientY }, cooldown = 1) {
        // Needed to make movement consistent across different fps rates 
        const amplitude = cooldown * this.#amplitude

        const deltaX = Utils.basicValue(clientX, this.#size.x)
        const deltaY = Utils.basicValue(clientY, this.#size.y)

        const parallaxX = -deltaX - this.position.x + this.#offset
        const parallaxY = deltaY - this.position.y + this.#offset

        if (!Number.isNaN(parallaxX)) this.position.x += parallaxX * amplitude
        if (!Number.isNaN(parallaxY)) this.position.y += (parallaxY / this.#aspect) * amplitude
    }

    #initMouseListener() {
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches)
            window.addEventListener("mousemove", (evnt) => {
                this.#timeout?.()
                this.#timeout = this.#clock.cooldown(
                    (cooldown, initialCooldown) => this.#track(evnt, cooldown / initialCooldown),
                    3 * (1000 / this.#clock?.delta || 1)
                )
            }, { passive: true })
    }

    constructor(size, clock, fov = 50, near = .01, far = 100) {
        const aspect = size.x / size.y

        super(fov, aspect, near, far)

        this.#aspect = aspect
        this.#clock = clock
        this.#size = size

        this.#initMouseListener()
    }

    resize(size) {
        this.#size = size
        this.aspect = size.x / size.y
        this.position.x = 0
        this.position.y = 0
        this.updateProjectionMatrix()
    }

    set offset(value) {
        this.#offset = value
        this.position.x += this.#offset
        this.position.y += this.#offset
    }
}
